export const getOrgSearched = state => state.refundExam.orgSearch.selected

export const getStudentSearched = state => state.refundExam.studentSearch.selected

export const getExamsSearched = state => state.refundExam.examSearch.exams

export const getExamsSearchedStatus = state => state.refundExam.examSearch

export const getExamsForRefundSubmissionStatus = state => state.refundExam.submit

export const getRefundedExamsData = state => {
  const {
    refundedExams: { data = [] },
  } = state
  return data
}

export const getRefundedExamsStatusProps = state => {
  const {
    refundedExams: { fetching, fetched, error },
  } = state
  return { fetching, fetched, error }
}
